import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const PricingSection: React.FC = () => {
  return <section id="comprar" className="py-14 md:py-24 px-4 bg-navy-800 relative" data-id="element-76">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-700 via-navy-800 to-navy-900" data-id="element-77"></div>

      <div className="max-w-md md:max-w-2xl mx-auto relative z-10" data-id="element-78">
        <div className="text-center mb-8 md:mb-12" data-id="element-79">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 text-white" data-id="element-80">
            TODO LO QUE NECESITÁS PARA TRABAJAR MEJOR COMO PSICÓLOGO/A
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-81">
            Un solo pago. Sin suscripciones. Tuyo para siempre.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-900 rounded-2xl md:rounded-3xl border-2 border-gold-500 overflow-hidden shadow-[0_0_30px_rgba(201,168,76,0.15)] md:shadow-[0_0_40px_rgba(201,168,76,0.15)]" data-id="element-82">
          <div className="bg-gold-500 text-navy-900 text-center py-2.5 md:py-3 font-bold text-base md:text-lg tracking-wider" data-id="element-83">
            🔥 OFERTA ESPECIAL — HOY
          </div>

          <div className="p-6 md:p-12" data-id="element-84">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-6 md:mb-8 text-center" data-id="element-85">
              KIT SESIONES CLÍNICAS
            </h3>

            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10" data-id="element-86">
              {['Método SESIÓN 4F', 'Pack de Plantillas Clínicas', <span key="b1" data-id="element-87">
                  <strong data-id="element-88">BONUS:</strong> 50 Intervenciones Clínicas Rápidas
                </span>, <span key="b2" data-id="element-89">
                  <strong data-id="element-90">BONUS:</strong> Guía Express Primera Sesión
                </span>].map((item, i) => <li key={i} className="flex items-center gap-3 text-base md:text-lg text-gray-200" data-id="element-91">
                  <Check className="w-5 h-5 md:w-6 md:h-6 text-gold-500 shrink-0" data-id="element-92" />
                  <span data-id="element-93">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-6 md:mb-8" data-id="element-94">
              <p className="text-gray-400 line-through text-xl md:text-2xl mb-1" data-id="element-95">
                $49.990
              </p>
              <p className="text-5xl md:text-6xl font-extrabold text-gold-500 mb-1 md:mb-2" data-id="element-96">
                $19.990 <span className="text-xl md:text-2xl" data-id="element-97">ARS</span>
              </p>
              <p className="text-xs md:text-sm text-gray-400" data-id="element-98">
                Pago único · Sin cargos ocultos
              </p>
            </div>

            <CTAButton text="SÍ, QUIERO EL KIT AHORA" className="w-full" isCheckout data-id="element-99" />

            <div className="mt-6 md:mt-8 flex items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-400" data-id="element-100">
              <div className="flex items-center gap-1.5 md:gap-2" data-id="element-101">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-gold-500" data-id="element-102" />
                <span data-id="element-103">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5 md:gap-2" data-id="element-104">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-gold-500" data-id="element-105" />
                <span data-id="element-106">Garantía 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};